import { Button } from '@fluentui/react-components';
import { Toast, ToastBody, ToastFooter, ToastTitle, useToastController } from '@galaxy-react/core';

import { useCallback } from 'react';
import { IToastProps } from 'src/Shared/Utilities/eventEmitter';

export const TOAST_ID = 'LR_TOAST_ID';

export const useToast = () => {
  const { dispatchToast } = useToastController(TOAST_ID);
  const notify = useCallback(
    ({ title, message, type, actions, duration = 3000 }: IToastProps & { duration?: number }) =>
      dispatchToast(
        <Toast intent={type}>
          <ToastTitle>{title}</ToastTitle>
          <ToastBody style={{ whiteSpace: 'pre-wrap' }}>{message}</ToastBody>
          {!!actions?.length && (
            <ToastFooter style={{ display: 'flex', gap: 8, flexDirection: 'row', justifyContent: 'flex-end' }}>
              {actions?.map((action) => (
                <Button key={action.label as string} onClick={action.onClick}>
                  {action.label}
                </Button>
              ))}
            </ToastFooter>
          )}
        </Toast>,
        {
          intent: type,
          timeout: duration,
          position: 'top-end',
          pauseOnWindowBlur: true,
          pauseOnHover: true,
        },
      ),
    [dispatchToast],
  );

  return { notify };
};
